import { createContext } from '@lit/context';
export const checkboxGroupDisabledContext = createContext('checkbox-group-disabled');
export const checkboxGroupReadonlyContext = createContext('checkbox-group-readonly');
//# sourceMappingURL=checkbox-group-context.js.map